import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import BankAnalyserLink from "./BankAnalyserLink";
import BankAnalyser from "./BankAnalyser";
const BankAnalyzerWrapper = (props) => {
  const { authToken } = useSelector((state) => state.login.authData);
  const [thirdPartyData, setThirdPartyData] = useState([]);
  const GetThirdPartyData = async () => {
    try {
      const result = await apiHandler({
        url: endpoint.CHECK_THIRD_PARTY_INTEGRATION,
        authToken: authToken,
      });
      console.log(result?.data, "thirdPartyData");
      if (!result?.data?.error_code) {
        setThirdPartyData(result?.data || []);
      }
    } catch (error) {
      console.log(error, "GetThirdPartyData error");
    }
  };
  useEffect(() => {
    if (authToken) {
      GetThirdPartyData();
    }
  }, [authToken]);
  const incomeVerify = thirdPartyData?.find(
    (item) => item?.integration === "INCOME_VERIFY"
  );
  const isAggregator =
    incomeVerify?.enabled === true && incomeVerify?.vendor === "AGGREGATOR";
  if (isAggregator) {
    return <BankAnalyserLink/>;
  }
  return <BankAnalyser/>;
};
export default BankAnalyzerWrapper;
